import React, { VFC } from 'react';
import { Row, Col } from 'react-grid-system';
import { theme } from '../../utils/theme';
import Spacing from '../atoms/Spacing';
import Typography from '../atoms/Typography';

interface Props {
  translationKey?: string;
}

const MissingData: VFC<Props> = ({ translationKey }) => (
  <Row>
    <Col>
      <Spacing spacing={4} />
      <Typography
        translateKey={translationKey || 'no_product_data'}
        align="center"
        variant="h3"
        color={theme.colors.grey[40]}
      />
      <Spacing spacing={4} />
    </Col>
  </Row>
);

export default MissingData;
